const doc = [({"no":({"js":({"components":({"score_factor_groups":({"mood_bar_chart":({"negative_label":"Antall negative klikk", "positive_label":" Antall positive klikk"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;